import * as React from "react";

import "./Icon.css";

const SvgUnitIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 47.96 47.96"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <path
      d="M-.08 16.09h48v15.67h-48z"
      style={{
        fill: "none",
        stroke: "currentColor",
        strokeMiterlimit: 10,
        strokeWidth: 2,
      }}
      transform="rotate(-45 23.919 23.922)"
    />
    <path d="m19.73 21.52 1.789-1.788 8.407 8.407-1.789 1.79zM6.685 35.427l1.789-1.789 8.407 8.408-1.789 1.789zM33.635 8.474l1.789-1.789 8.407 8.408-1.789 1.789zM16.293 31.55l1.789-1.788 5.536 5.537-1.789 1.789zM29.77 18.074l1.789-1.789 5.536 5.537-1.789 1.789z" />{" "}
  </svg>
);
export default SvgUnitIcon;
